<template>
  <section class="result-wrapper detail-page">
    <div class="container">
      <div class="pre-fill">
        <div class="row">
          <div class="col-12 col-xs-6">
            <label>{{ t("filter.loan_amount") }}</label>
            <MoneyInput :value="amount" @change="amountChange" />
          </div>
          <div class="col-12 col-xs-6">
            <label>{{ t("filter.repayment_period") }}</label>
            <IntegerInput
              ref="tenor"
              :label="t('filter.month_unit')"
              :value="tenor"
              @change="monthChange"
              min="6"
            />
          </div>
        </div>
      </div>
      <div class="result-list result-list-wrapper popup-share">
        <div class="result-head">
          <div class="row">
            <div class="col-4">
              {{ t("loan.orgranization") }}
            </div>
            <div class="col-8">
              <div class="row">
                <table>
                  <thead>
                    <tr>
                      <th>{{ t("loan.min_rate") }}</th>
                      <th width="150" class="md">
                        {{ t("loan.total_amount") }}
                      </th>
                      <th width="100" class="md">
                        {{ t("loan.tenor") }}
                      </th>
                      <th width="70" class="sm">
                        {{ t("loan.tu") }}
                      </th>
                      <th width="100" class="md">
                        {{ t("mortgage.payment_method") }}
                      </th>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
          </div>
        </div>
        <LoanCard :item="detail" @share="shareHandle" hide-detail-button />
        <Share
          v-if="showShare"
          v-click-outside="hideShare"
          :title="detail.shareMsg"
          :id="detail.id"
        />
      </div>
      <hr />
      <div class="detail-content detailField">
        <div v-html="detail.detail" />
      </div>
    </div>
  </section>
</template>
<script>
import MoneyInput from "@/components/form/MoneyInput.vue";
import IntegerInput from "@/components/form/IntegerInput.vue";
import commonFunc from "~/assets/js/commonHelper.js";
import LoanCard from "@/components/search/LoanCard";
import Share from "@/components/layout/Share";
export default {
  components: {
    LoanCard,
    Share,
    MoneyInput,
    IntegerInput,
  },
  data: function () {
    return {
      detail: [],
      tenor: 0,
      selectedMonth: "",
      selectedAmount: "",
      amount: 0,
      showShare: false,
    };
  },
  layout(context) {
    return "default";
  },
  head() {
    const logo =
      this.detail.logo.split("?").length > 1
        ? this.detail.logo.split("?")[0]
        : this.detail.logo;
    return {
      // title: title,
      // meta: commonFunc.getSeoMeta(this.$store.state.layout.seo, logo),
      ...commonFunc.getSeoMeta(this.$store.state.layout.seo, logo),
      bodyAttrs: {
        class: "loan-page"
      },
    };
  },
  computed: {},
  watch: {},
  async asyncData({ store, route, redirect }) {
    const { tenor, amount, previewToken } = route.query;
    const slug = route.params.slug;
    const id = commonFunc.getIdFromSlug(slug);
    const params = {
      tenor: tenor || 12,
      id: id,
      amount: amount || 50000,
      previewToken: previewToken,
    };
    await store.dispatch("search/fetchList", { type: "loan", params: params });
    await store.dispatch("search/fetchTags", { type: "loan" });
    await store.dispatch("option/fetchLoanCalculateMethod");
    const methods = JSON.parse(
      JSON.stringify(store.state.option.loanCalculateMethods)
    );
    const methodList = {};
    methods.forEach((item) => {
      methodList[item.code] = item.name;
    });
    const list = JSON.parse(JSON.stringify(store.state.search.list));
    const detail = list[0];
    if (detail === undefined) {
      return redirect("/not_found");
    }
    const tags = {};
    const tagList = JSON.parse(JSON.stringify(store.state.search.tags));
    tagList.forEach((item) => {
      tags[item.code] = item.name;
    });
    detail.logo = detail.company.logo;
    detail.tags = [];
    detail.features.forEach((tag) => {
      if (tags[tag] !== undefined) {
        detail.tags.push(tags[tag]);
      }
    });
    detail.method = methodList[detail.calculateMethod]
      ? methodList[detail.calculateMethod]
      : "-";
    await store.dispatch("layout/fetchSeo", {
      path: route.path,
      title: detail.detailTitle + " | MoneyPlaza",
    });
    return { detail: detail, tenor: params.tenor, amount: params.amount };
  },
  mounted() {
    this.selectedAmount = this.amount;
    this.selectedMonth = this.tenor;
  },
  methods: {
    hideShare: function () {
      this.showShare = false;
    },
    shareHandle: function () {
      this.showShare = true;
    },
    formatImageUrl: function (val) {
      const pathes = val.split("?");
      return pathes.length > 1 ? pathes[0] : val;
    },
    monthChange: function (val) {
      this.selectedMonth = val;
      this.filterChange();
    },
    amountChange: function (val) {
      this.selectedAmount = val;
      this.filterChange();
    },
    filterChange: async function () {
      this.$router.replace({
        query: { tenor: this.selectedMonth, amount: this.selectedAmount },
      });
      const params = {
        tenor: this.selectedMonth,
        id: this.detail.id,
        amount: this.selectedAmount,
      };
      await this.$store.dispatch("search/fetchList", {
        type: "loan",
        params: params,
      });
      const list = JSON.parse(JSON.stringify(this.$store.state.search.list));
      const detail = list[0];
      this.detail.totalPaymentAmount = detail.totalPaymentAmount;
      this.detail.scheduledPaymentAmount = detail.scheduledPaymentAmount;
      this.detail.interestRate = detail.interestRate;
    },
  },
};
</script>